export enum GenerateFormType {
  TEXT = 1,
  SELECT = 2,
  MULTIPLE_SELECT = 3,
  SINGLE_SELECT = 4,
  TEXT_MASK = 5,
  TEXT_CURRENCY_MASK = 6,
  PASSWORD = 7
}
